<p class="mb-6 text-generic">
    {{ 'COMPANY_REGISTRATION.ENTER_DETAILS' | translate }}
</p>

<form [formGroup]="tradeLicenseDetailsForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">
    <!-- Section Title -->
    <p class="text-base font-medium mb-6 text-(--text-muted)">
        {{'TRADE_LICENSE.PROFESSION_LICENSE_DETAILS' | translate}}
    </p>

    <!-- Responsive grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <!-- Trade Name -->
        <div class="sm:col-span-2">
            <app-input-field label="{{ 'TRADE_LICENSE.TRADE_NAME' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                [control]="getControl('tradeName')"></app-input-field>
        </div>

        <!-- Country of Registration -->
        <div>
            <app-custom-dropdown label="TRADE_LICENSE.COUNTRY_OF_REGISTRATION" placeholder="TRADE_LICENSE.PLEASE_SELECT"
                [options]="countriesOptions" [isSearchable]="true"
                searchPlaceholder="{{'TRADE_LICENSE.SEARCH_COUNTRY' |translate}}"
               (optionSelected)="onDropdownSelect('countryOfRegistration', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Empty space for alignment -->
       <div class="sm:block hidden"></div>

        <!-- License Number -->
        <div>
            <app-input-field label="{{ 'TRADE_LICENSE.PROFESSIONS_LICENSE_NUMBER' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                [control]="getControl('licenseNumber')"></app-input-field>
        </div>

        <!-- License Expiry Date -->
        <div>
            <app-date-picker label="TRADE_LICENSE.PROFESSION_LICENSE_EXPIRY" placeholder="DD/MM/YYYY"
                [control]="getControl('licenseExpiryDate')"
                [errorMessage]="'Invalid date format'" modalTitle="Select license expiry date">
            </app-date-picker>
        </div>

        <!-- Certificate Upload -->
        <div class="sm:col-span-2">
            <app-single-file-upload title="TRADE_LICENSE.CERTIFICATE_OF_REGISTRATION" [control]="getControl('certificateOfRegistration')"
                acceptedTypes=".jpg,.png,.pdf,.doc" [maxSizeMB]="5"></app-single-file-upload>
        </div>

        <!-- Section Title -->
        <p class="text-base font-medium mb-0 sm:col-span-2 text-(--text-muted)">
            {{'TRADE_LICENSE.TRADING_LICENSE_DETAILS' | translate}}
        </p>

        <!-- Governorate -->
        <div>
            <app-custom-dropdown label="TRADE_LICENSE.GOVERNORATE" placeholder="TRADE_LICENSE.PLEASE_SELECT"
                [options]="governateOptions" [isSearchable]="true"
                searchPlaceholder="{{'TRADE_LICENSE.SEARCH_GOVERNORATE'|translate}}"
                (optionSelected)="onDropdownSelect('governate', $event)" customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Trade License Issuer -->
        <div>
            <app-custom-dropdown label="TRADE_LICENSE.TRADE_LICENSE_ISSUER" placeholder="TRADE_LICENSE.PLEASE_SELECT"
                [options]="licenseIssuerOptions" (optionSelected)="onDropdownSelect('tradeingLicenseIssuer', $event)"
                customClass="!mb-0"></app-custom-dropdown>
        </div>

        <!-- Trade License Number -->
        <div>
            <app-input-field label="{{ 'TRADE_LICENSE.TRADING_LICENSE_NUMBER' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                [control]="getControl('tradingLiscenseNumber')"></app-input-field>
        </div>

        <!-- Issuing Date -->
        <div>
            <app-date-picker label="TRADE_LICENSE.TRADING_LICENSE_ISSUING_DATE" placeholder="DD/MM/YYYY"
                [control]="getControl('tradingLiscenseIssuingDate')"
                [errorMessage]="'Invalid date format'" modalTitle="Select license issuing date">
            </app-date-picker>
        </div>

        <!-- Trading Certificate -->
        <div class="sm:col-span-2">
            <app-single-file-upload title="TRADE_LICENSE.TRADING_CERTIFICATE" acceptedTypes=".jpg,.png,.pdf,.doc"
                [maxSizeMB]="5" [control]="getControl('tradingCertificate')"></app-single-file-upload>
        </div>
    </div>

    <!-- Submit Button -->

    <app-button text="{{ 'LOGIN.CONTINUE' | translate }}" type="submit" variant="primary" size="lg"
        extraClass="mt-3 mb-12 w-full" [disabled]="tradeLicenseDetailsForm.invalid"></app-button>

</form>